// eslint-disable-next-line import/prefer-default-export
export const GetVolunteersSelector = ({ volunteers: { GetVolunteers } }) =>
  GetVolunteers;

export const PostVolunteersSelector = ({ volunteers: { PostVolunteers } }) =>
  PostVolunteers;
